import React, { createRef, useEffect, useState } from "react";
import { useResetInputs } from "src/Contexts";
import { ModalCore } from "src/Pages/components";

import { UseFormContracts } from "./Hooks/UseFeaturesFormulario";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { FormContrato } from "./FormContrato";
import { FormTitular } from "./FormTitular";
import { FormContato } from "./FormContato";
import { FormDados } from "./FormDados";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { UploadWithIAContract } from "./UploadContract/UploadWithIAContract";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface IModalContracts {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalContracts = ({
  openModal,
  setOpenModal,
}: IModalContracts) => {
  const { resetInputs } = useResetInputs();
  const navigate = useNavigate();
  const [openContato, setOpenContato] = useState(false);
  const { handleSubmit, loading: loadingSubmit } = UseFormContracts({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();

    if (!openModal) {
      navigate(location.pathname, { replace: true }); // remove o setOpen
    }
  }, [openModal]);

  const inputRef = createRef<HTMLInputElement>();

  const handleFocusedID = () => inputRef.current?.focus();

  useEffect(() => {
    handleFocusedID();
  }, []);

  return (
    <ModalCore
      open={openModal}
      setOpen={setOpenModal}
      loadingSubmit={loadingSubmit}
      sxStyle={{ width: { xl: "1100px", md: "600", xs: "90%" } }}
      title="Contrato"
      titleSubmit="Salvar"
      onChange={handleSubmit}
    >
      <UploadWithIAContract />

      <DividerCore title="Contrato" sxStyle={{ marginTop: "0" }} />
      <FormContrato inputRef={inputRef} />

      <DividerCore title="Cliente" />
      <FormTitular />

      <DividerCore
        title="Contato / Endereço"
        button={
          <IconButton
            sx={{ p: 0 }}
            onClick={() => setOpenContato(!openContato)}
          >
            {openContato ? (
              <KeyboardArrowDownIcon fontSize="small" />
            ) : (
              <KeyboardArrowRightIcon fontSize="small" />
            )}
          </IconButton>
        }
      />
      {openContato && <FormContato />}

      <DividerCore title="Dados" />
      <FormDados />
    </ModalCore>
  );
};
